import pro1 from "../assets/Pro1.jpg";
import pro2 from "../assets/Pro2.jpg";
import pro3 from "../assets/Pro3.jpg";
import pro4 from "../assets/Pro4.jpeg";

const ProjectCardData = [
  {
    imgsrc: pro1,
    title: "AI Navigational Bot",
    category: "Machine Learning",
    tags: ["Python", "Flask", "NLP", "Neural Networks"],
    text: "An AI chatbot built to streamline navigation and information retrieval. NLP techniques — tokenization, bag-of-words, and stemming — feed a feed-forward neural network trained for real-world accuracy and continuous improvement.",
    source: "https://github.com/Aamir10-02/AI-Navigational-Bot",
    view: "https://aamirsporfolio.com/",
  },
  {
    imgsrc: pro4,
    title: "Django E-Commerce Platform",
    category: "Full Stack",
    tags: ["Django", "PostgreSQL", "PayPal", "Railway"],
    text: "Production e-commerce platform with authentication, cart flows, order tracking, and an admin dashboard. PayPal integration, PostgreSQL persistence, and CI/CD deployment on Railway.",
    source: "https://github.com/Aamir10-02/DJANGO-E-Commerce-Website",
    view: "https://djangoecom.store/",
  },
  {
    imgsrc: pro3,
    title: "Business Website",
    category: "Frontend",
    tags: ["React", "JavaScript", "CSS", "Netlify"],
    text: "A polished business presence with responsive layout, modern visual hierarchy, and performance-focused delivery — built to convert visitors into clients.",
    source: "https://github.com/Aamir10-02",
    view: "https://zingy-entremet-d95f05.netlify.app/",
  },
  {
    imgsrc: pro2,
    title: "Flask Registration Form",
    category: "Backend Integration",
    tags: ["Flask", "Google Sheets", "Google API", "Heroku"],
    text: "Registration system that writes directly to Google Sheets via the Google API. Secure data handling, clean UX, and real-time spreadsheet sync on Heroku.",
    source: "https://github.com/Aamir10-02/Spread-Form",
    view: "https://spread-form-5ac555ebda98.herokuapp.com/",
  },
];

export default ProjectCardData;
